import { render } from "./EditWorkStationUser.vue?vue&type=template&id=4fbc5d54&scoped=true"
import script from "./EditWorkStationUser.vue?vue&type=script&lang=js"
export * from "./EditWorkStationUser.vue?vue&type=script&lang=js"

import "./EditWorkStationUser.vue?vue&type=style&index=0&id=4fbc5d54&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fbc5d54"]])

export default __exports__